import { connect } from 'react-redux'

import { addRentalReputationBackUrl } from 'app/shared_components/actions'
import { fetchApplication } from 'app/sm/apply/apply_actions'
import {
  getEmergencyContacts,
  removeEmergencyContact,
} from 'app/sm/emergency_contact/emergency_contact_actions'
import EmergencyContactAdd from 'app/sm/emergency_contact/emergency_contact_add'
import { fetchCompleteness } from 'app/sm/rental_reputation/actions'

const mapStateToProps = ({
  session,
  EmergencyContact,
  Shared,
  RentalReputation,
  apply,
}) => ({
  emergencyContacts: EmergencyContact.emergencyContacts,
  backUrl: Shared.backUrl,
  currentUser: session.currentUser,
  completeness: RentalReputation.completeness,
  applicationDetails: apply.application,
})

const mapDispatchToProps = (dispatch) => ({
  getEmergencyContacts: () => dispatch(getEmergencyContacts()),
  removeEmergencyContact: (id) => dispatch(removeEmergencyContact(id)),
  addRentalReputationBackUrl: (rentalBackUrl) =>
    dispatch(addRentalReputationBackUrl(rentalBackUrl)),
  fetchCompleteness: () => dispatch(fetchCompleteness()),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EmergencyContactAdd)
